import {Pipe, PipeTransform} from '@angular/core';
import {EventType} from '@app/shared';

@Pipe({
  name: 'serviceOrderState',
  standalone: false
})
export class ServiceOrderStatePipe implements PipeTransform {
  transform(status: string | number, events: EventType[]): { name: string, class: string, icon: string } {
    if (!status) {
      return { name: 'Sin estado', class: 'subtle-grey', icon: '' };
    }

    // Convertir status a número para comparación consistente
    const statusNum = typeof status === 'number' ? status : parseInt(status);
    const event = events.find(e => e.id === statusNum);

    if (event?.name === 'Tarea creada' || event?.name === 'Orden creada') event.color = '#FF990A';
    if (event?.name === 'Tarea finalizada' || event?.name === 'Orden finalizada') event.color = '#45A557';

    if (event) {
      // Mapear nombres antiguos a nuevos (para compatibilidad con BD)
      let eventName = event.name;
      if (eventName === 'Orden creada') eventName = 'Tarea creada';
      if (eventName === 'Orden finalizada') eventName = 'Tarea finalizada';

      let clase: string;
      switch (event.color) {
        case '#0072F5': // Por Hacer
          clase = 'subtle-blue';
          break;
        case '#0d6efd': // En Progreso (Bootstrap azul)
          clase = 'subtle-teal';
          break;
        case '#A8A8A8':
          clase = 'subtle-grey';
          break;
        case '#8E4EC6':
        case '#6f42c1': // Revisión Interna (Bootstrap morado)
          clase = 'subtle-purple';
          break;
        case '#FF990A':
        case '#ffc107': // En Espera (Bootstrap amarillo)
          clase = 'subtle-amber';
          break;
        case '#E5484D':
        case '#dc3545': // Cancelada (Bootstrap rojo)
          clase = 'subtle-red';
          break;
        case '#EA3E83':
          clase = 'subtle-pink';
          break;
        case '#45A557':
        case '#198754': // Completada (Bootstrap verde)
          clase = 'subtle-green';
          break;
        case '#12A594':
          clase = 'subtle-teal';
          break;
        default:
          clase = 'black';
          break;
      }
      return { name: eventName, class: clase, icon: event.icon || '' }
    } else {
      return { name: 'Sin estado', class: 'subtle-grey', icon: '' };
    }
  }
}
